import React from 'react';
import { Outlet } from 'react-router-dom';

import { Container, Section } from '../../../../../components';

import './MyProjects.scoped.scss';

const MyProjects = () => {
  return (
    <Section>
      <Container>
        <Outlet />
      </Container>
    </Section>
  );
};

export default MyProjects;
